import { NetworkService } from './network-service';

const API_BASE_URL = process.env.REACT_APP_API_EXECUTION_ADDRESS;

export default class PlansService {
    static async getPlansAsync() {
        const response = await NetworkService.getAsync(`${API_BASE_URL}/plans`);
        return response;
    }
}
